import React from 'react';

export const Lightning = (props) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.4237 10.6992H17.4565L10.2917 19.6552L11.9087 13.8802L12.1753 12.928H11.1864H7.14652L14.0927 4.18093L12.6961 9.76725L12.4631 10.6992H13.4237Z"
      stroke="black"
      strokeWidth="1.5"
    />
  </svg>
);
